/**
 * Kalıcı (301) yönlendirmeler — tek kaynak.
 * Sunucu (server/seo/routes.ts) 301 döner, istemci (App.tsx) aynı haritayla yönlendirir;
 * sitemap, site haritası ve açılış sayfası listeleri bu haritadaki kaynak yolları dışarıda bırakır.
 *
 * Ekim 2026 sadeleştirmesi: aynı aramayı hedefleyen açılış sayfaları ve şablonla üretilmiş
 * "X'ten Y'ye geçiş" / "X reklam ajansı" sayfaları, doorway (kapı sayfası) riskini önlemek için
 * en güçlü ana sayfada birleştirildi. Kaynak sayfaların SSS'leri hedef sayfaya taşınır.
 */
import { ALTYAPILAR, gecisSlug, ajansSlug, GECIS_HUB_SLUG } from "./altyapi_gecis_data";
import { YAZAR_YONLENDIRMELERI } from "./yazarlar";

const SABIT: Record<string, string> = {
  // Eski vaka adresi → anonim adres
  "/referanslar/qarmacha-ikas-meta-olcekleme": "/referanslar/ikas-kadin-giyim-markasi-olcekleme",

  // Meta / Facebook kümesi → tek sayfa
  "/facebook-reklam-ajansi": "/meta-reklam-ajansi",
  // Çok kanallı / genel reklam ajansı → e-ticaret reklam ajansı
  "/facebook-google-ads-reklam-yonetimi": "/e-ticaret-reklam-ajansi",
  "/dijital-reklam-ajansi": "/e-ticaret-reklam-ajansi",
  // Dijital pazarlama kümesi → dijital pazarlama ajansı
  "/dijital-pazarlama-uzmani": "/dijital-pazarlama-ajansi",
  // E-ticaret ajansı sorguları (GSC'de gösterimin %68'i) e-ticaret reklam ajansı sayfasına devredilir
  "/e-ticaret-dijital-pazarlama-ajansi": "/e-ticaret-reklam-ajansi",
  // Google kümesi → Google Ads ajansı
  "/google-reklam-uzmani": "/google-ads-ajansi",
  // Pazaryeri kümesi → pazaryeri reklam ajansı
  "/trendyol-reklam-yonetimi": "/pazaryeri-reklam-ajansi",
  // Performans kümesi → performans pazarlama ajansı
  "/buyume-ajansi": "/performans-pazarlama-ajansi",
  "/medya-planlama-ajansi": "/performans-pazarlama-ajansi",
  // Yapay zeka kümesi
  "/yapay-zeka-reklam-kreatifi": "/yapay-zeka-reklam-ajansi",

  // ikas: açılış sayfası ile platform hizmet sayfası aynı aramayı hedefliyordu
  "/ikas-e-ticaret-ajansi": "/ikas",
  "/ikas-meta-reklam-ajansi": "/ikas/meta-reklam-yonetimi",
  "/ikas-google-ads-ajansi": "/ikas/google-ads-yonetimi",
  "/ikas-magaza-kurulum-ajansi": "/ikas/magaza-kurulumu",
  // Shopify: aynı durum
  "/shopify-ajansi": "/shopify",
  "/shopify-eticaret-kurulum": "/shopify/magaza-kurulumu",
  "/shopify-eticaret-reklam-yonetimi": "/shopify-reklam-ajansi",
};

/** Şablonla üretilmiş geçiş ve altyapı-ajans sayfaları → platform geçiş sayfaları ve geçiş merkezi */
function altyapiYonlendirmeleri(): Record<string, string> {
  const m: Record<string, string> = {};
  for (const a of ALTYAPILAR) {
    for (const h of a.hedefler) m[`/${gecisSlug(a, h)}`] = h === "ikas" ? "/ikas/ikasa-gecis" : "/shopify/shopifya-gecis";
    if (a.ajansSayfasi) m[`/${ajansSlug(a)}`] = `/${GECIS_HUB_SLUG}`;
  }
  return m;
}

export const YONLENDIRMELER: Record<string, string> = { ...altyapiYonlendirmeleri(), ...YAZAR_YONLENDIRMELERI, ...SABIT };

/**
 * Kısa eş adresler: hiç yayında olmamış, yalnızca sık yazılan karşılıkları kanonik sayfaya taşıyan 301'ler.
 * Birleştirilen sayfa değillerdir; bu yüzden P04 geçici yönlendirme sitemap'ine (buildYonlendirmeSitemapXml)
 * ve ek içerik (SSS) taşımasına (ek_icerik/index.ts) girmezler; bu iki yer YONLENDIRMELER'i okumaya devam eder.
 */
export const KISA_ADRESLER: Record<string, string> = {
  "/faq": "/sss",
  "/sikca-sorulan-sorular": "/sss",
  // Yapay zekâ asistanları (ChatGPT-User) ve bingbot bu tahmini adresleri istiyordu (3 Kasım, Cloudflare: 404)
  "/iletisim": "/randevu",
  "/hakkimizda": "/kurumsal",
};

/** Sunucu 301'i (routes.ts) ve istemci yönlendirmesi (App.tsx) için tam harita */
export const TUM_YONLENDIRMELER: Record<string, string> = { ...YONLENDIRMELER, ...KISA_ADRESLER };

/** Yol yönlendirilmiş (kaldırılmış ya da kısa eş adres) mi? */
export const yonlendirildiMi = (yol: string) => Object.prototype.hasOwnProperty.call(TUM_YONLENDIRMELER, yol.replace(/\/+$/, "") || "/");
